import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'pdv-section-header',
  standalone: true,
  templateUrl: './section-header.component.html',
  styleUrls: ['./section-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionHeaderComponent {
  @Input() title = '';
}
